export default __webpack_public_path__ + "static/media/SpiderImageLevelsOfMaturity.39318e19.png";